import { IResponse } from "models";

export enum ActionType {
  DEFAULT_SETTING = "action/DEFAULT_SETTING",
  DEFAULT_SETTING_SUCCESS = "action/DEFAULT_SETTING_SUCCESS",
  DEFAULT_SETTING_ERROR = "action/DEFAULT_SETTING_ERROR",
  DEFAULT_SETTING_RESET = "action/DEFAULT_SETTING_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDefaultSettingPayload {
  is_verify_identity_code: boolean;
  identity_code_title: string;
  is_show_title: boolean;
}

export interface IDefaultSettingResponse extends IResponse {
  result: any;
}
